var map = {
	"./arrow1.svg": 8550,
	"./arrow2.svg": 4773,
	"./banner-bg.png": 9368,
	"./color-sharp.png": 4468,
	"./color-sharp2.png": 4972,
	"./contact-img.svg": 9636,
	"./footer-bg.png": 8801,
	"./header-img.jpg": 8433,
	"./header-img.svg": 9987,
	"./icon-about-me.svg": 3068,
	"./icon-cv.svg": 5929,
	"./icon-email.svg": 9230,
	"./icon-google-scholar.svg": 5602,
	"./icon-twitter-bird.svg": 5085,
	"./icon-up-arrow.svg": 8013,
	"./icon-up-arrow_2.svg": 9890,
	"./logo.svg": 7503,
	"./meter1.svg": 7298,
	"./meter2.svg": 8049,
	"./meter3.svg": 16,
	"./nav-icon1.svg": 710,
	"./nav-icon2.svg": 8933,
	"./nav-icon3.svg": 6324,
	"./project-basketbot_cover.jpg": 5863,
	"./project-basketbot_video_1.mp4": 6848,
	"./project-calibread_cover.png": 1819,
	"./project-calibread_image_1.jpg": 9797,
	"./project-calibread_image_2.png": 46,
	"./project-calibread_image_3.png": 39,
	"./project-cometic_cover.png": 8194,
	"./project-cometic_image_1.png": 4444,
	"./project-cometic_image_2.png": 8375,
	"./project-fluid_simulation_cover.png": 7362,
	"./project-fluid_simulation_video_1.mp4": 8335,
	"./project-fluid_simulation_video_2.mp4": 712,
	"./project-furifist_cover.jpg": 6038,
	"./project-furifist_image_1.png": 2076,
	"./project-furifist_video_1.mp4": 3215,
	"./project-img1.png": 9394,
	"./project-img2.png": 4537,
	"./project-img3.png": 9712,
	"./project-interact_with_iot_cover.png": 2958,
	"./project-interact_with_iot_video_1.mp4": 1481,
	"./project-keepout_cover.png": 979,
	"./project-keepout_image_1.png": 2365,
	"./project-my_origami_cover.jpg": 4505,
	"./project-my_origami_video_1.mp4": 3912,
	"./project-my_origami_video_2.mp4": 5183,
	"./project-my_origami_video_3.mp4": 234,
	"./project-my_origami_video_4.mp4": 977,
	"./project-my_origami_video_5.mp4": 8012,
	"./project-my_origami_video_6.mp4": 1059,
	"./project-my_origami_video_7.mp4": 4670,
	"./project-my_origami_video_8.mp4": 5013,
	"./project-thermotion_cover.gif": 132,
	"./project-understanding_overreliance_cover.png": 7012,
	"./project-understanding_overreliance_image_1.png": 4934,
	"./project-understanding_overreliance_image_2.png": 6141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;